// import HomePage from './pages/HomePage';
import SignUpPage from './pages/SignUpPage';
//import PageNotFound from '../components/pages/PageNotFound';
import LoginPage from "./pages/LoginPage";
import ResetPassowrd from "./pages/ForgetPassword";
import GanttContainer from "./timeline/ganttContainer/GanttContainer";

export default [
  {
    path: "/timeline",
    component: GanttContainer,
    exact: true,
  },
  {
    path: "/",
    component: LoginPage,
    exact: true,
  },
  {
    path: "/signup",
    component: SignUpPage,
    exact: true,
  },
  {
    path: "/__/auth/action",
    component: ResetPassowrd,
  },
  {
    path: "*",
    component: LoginPage,
    exact: true,
  }
];
